import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { queryClient } from '@/config/query-client'
import { installationId } from '@/features/notification/push/deviceIdentity'
import { logout as apiLogout } from '@/services/api/auth.service'
import { removeInstallation } from '@/services/api/device.service'
import { useAuthStore } from '@/stores/auth.store'
import { usePermissionStore } from '@/stores/permission.store'
import { useSubscriptionStore } from '@/stores/subscription.store'
import { useWorkspaceStore } from '@/stores/workspace.store'

export function useAuth() {
  const navigate = useNavigate()
  const { accessToken, userId, logout, setLoading } = useAuthStore()
  const workspaceStore = useWorkspaceStore()
  const permissionStore = usePermissionStore()
  const subscriptionStore = useSubscriptionStore()

  const isAuthenticated = !!accessToken

  const handleLogout = async () => {
    // While still signed in: this phone or browser must not keep getting this person's notifications.
    await installationId().then(removeInstallation).catch(() => undefined)
    try {
      await apiLogout()
    } catch {
      // Ignore errors
    }

    queryClient.cancelQueries()
    queryClient.clear()
    logout()
    workspaceStore.clearWorkspace()
    permissionStore.clear()
    subscriptionStore.clear()
    setLoading(false)

    navigate('/login', { replace: true })
  }

  return {
    isAuthenticated,
    accessToken,
    userId,
    logout: handleLogout,
  }
}

export function useRequireAuth() {
  const { accessToken, isLoading } = useAuthStore()
  const navigate = useNavigate()

  const isAuthenticated = !!accessToken

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login', { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate])

  return { isAuthenticated, isLoading }
}